/**
 * Cart Counter - Updates the shopping cart icon count from cookie (set by preact/shopware components)
 */

(function () {
  const CART_COUNT_KEY = 'sw-cart-count';
  const CART_LINK_ID = 'shopping-cart-link';

  /**
   * Gets a cookie value
   */
  function getCookie(name) {
    try {
      const nameEQ = encodeURIComponent(name) + '=';
      const cookies = document.cookie.split(';');

      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        while (cookie.charAt(0) === ' ') {
          cookie = cookie.substring(1);
        }
        if (cookie.indexOf(nameEQ) === 0) {
          return decodeURIComponent(cookie.substring(nameEQ.length));
        }
      }

      return null;
    } catch (e) {
      return null;
    }
  }

  function updateCartCount() {
    const cartLink = document.getElementById(CART_LINK_ID);
    if (!cartLink) {
      return;
    }

    try {
      const storedCount = getCookie(CART_COUNT_KEY);
      const itemCount = storedCount ? parseInt(storedCount, 10) : 0;

      // Only update if we have a valid number and the attribute is different
      if (!isNaN(itemCount)) {
        const currentCount = cartLink.getAttribute('data-item-count');
        if (currentCount !== itemCount.toString()) {
          cartLink.setAttribute('data-item-count', itemCount.toString());
        }
      }
    } catch {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCartCount);
  } else {
    updateCartCount();
  }
})();
